import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialSlackIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialSlack",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.37 2.18a2.91 2.91 0 0 0-3.09 2.73A2.91 2.91 0 0 0 12.01 8h3.27V5.08c0-1.6-1.3-2.91-2.91-2.91ZM19.63 15.28c1.61.03 2.94-1.25 2.97-2.86V5.09a2.91 2.91 0 0 0-3.09-2.73 2.91 2.91 0 0 0-2.73 2.73v7.27c0 1.61 1.3 2.91 2.91 2.92zM29.82 12.36a2.91 2.91 0 0 0-3.09-2.73A2.91 2.91 0 0 0 24 12.36v2.92h2.91c1.61 0 2.92-1.31 2.92-2.92ZM26.9 16.73h-7.27c-1.61.1-2.83 1.48-2.73 3.09a2.91 2.91 0 0 0 2.73 2.73h7.27c1.61.1 2.99-1.12 3.09-2.73s-1.12-2.99-2.73-3.09zM19.63 23.99h-2.91v2.92c0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92zM12.37 16.73c-1.6 0-2.91 1.29-2.92 2.89v7.279999999999999c.1 1.61 1.48 2.83 3.09 2.73a2.91 2.91 0 0 0 2.73-2.73v-7.27c0-1.6-1.3-2.91-2.91-2.91ZM2.18 19.63a2.91 2.91 0 0 0 2.73 3.09c1.61.1 2.99-1.12 3.09-2.73v-3.27H5.09c-1.61 0-2.91 1.3-2.92 2.91ZM12.37 9.46H5.1a2.91 2.91 0 0 0-3.09 2.73 2.91 2.91 0 0 0 2.73 3.09h7.63c1.61-.1 2.83-1.48 2.73-3.09a2.91 2.91 0 0 0-2.73-2.73"
    })
  }));
};